import {Component, ElementRef, Input, Renderer2} from '@angular/core';
import { GlobalServiceProvider} from "../../../providers/global.service";
import { ApiServiceProvider} from "../../../providers/api.service";
import {Observable} from "rxjs/Observable";
import 'rxjs/add/observable/of';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {CommandComponent} from "../command-component";

/**
 * Generated class for the ParticipantListCmdComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

declare var window;

@Component({
  selector: 'document-detail-cmd',
  templateUrl: 'document-detail-cmd.html'
  // template:'<div *ngFor="let c of participants" (click)="clicked(c)">{{c.username}}</div>'
})


export class DocumentDetailCmdComponent implements CommandComponent{

  text: string;
  @Input() public document: Object;



  public static count=0;
  public _count;


  public participantForm: FormGroup;

  constructor(
              public global: GlobalServiceProvider,
              public api: ApiServiceProvider,
              private fb: FormBuilder,
              private renderer: Renderer2) {

    debugger;

  }


  getDocumentWithName(username){
    this.document= this.global.documentsByName[username]
  }

  ngOnInit(){

  }







  public clicked(c)
  {
    console.log("clicked", c);

  }




  makeEditable(document){
    let formObj: Array<FormControl> = [];

  }


  save(p){
    this.document = p;
    let result =  this.global.createDocument(p);
    return result;
  }


  public setData(p){
    debugger;
    this.document = p
  }
}



// WEBPACK FOOTER //
// ./src/components/commands/document-detail-cmd/document-detail-cmd.ts